<script setup lang="ts">
import type { NovaSearchResultItemCommentProps } from './NovaSearchResultItemComment.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaSearchResultItemCommentProps>()
const { gtEvent } = useGoogleTag()
const route = useRoute()
const { humanize } = useDateFormat()

const handleOnShowPostDetailModal = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '포스트 상세보기',
    eventLabel: '',
    eventSlot: '검색 > 댓글',
    eventI18nAddr: '',
    eventComponent: 'Modal',
    cmtyNttSn: props.source.cmtyNttSn,
    nttSj: props.source.nttSj,
  })
  useNavigations({
    url: useRoutePathIdChange(ROUTES.SEARCH_DETAIL_COMMENT_DETAIL.path, {
      id: String(props.source.cmtyNttSn),
    }),
    query: route.query,
  })
}
</script>

<template>
  <div class="search-result-item-comment" @click="handleOnShowPostDetailModal">
    <NovaPortraitContainer
      :size="'sm'"
      :empty-type="'portrait'"
      :image-url="source.profilePath"
    />

    <span class="inner">
      <span class="metas">
        <span class="user-name">{{ source.userNcnm }}</span>
        <span class="create-at">
          {{ humanize(source.nttRegistDt) }}
        </span>
      </span>
      <span v-dompurify-html="source.nttSj" class="description" />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.search-result-item-comment {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 20px;
  background-color: $color-bg-3;
  border-radius: $radius-10;
  cursor: pointer;

  > .inner {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

    .metas {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: $color-text-2;

      .user-name {
        @include text-style($text-body-14-bold);
        letter-spacing: 0;

        &:after {
          display: inline-block;
          content: '•';
        }
      }

      .create-at {
        @include text-style($text-body-12-regular);
      }
    }
    .description {
      @include text-style($text-body-14-regular);
      @include ellipsis(2);
      line-height: 20px;
      letter-spacing: 0;
      color: $color-text-3;
    }
  }

  @include mobile {
    gap: 10px;
    padding: 15px 10px;
  }
}
</style>
